import { render, staticRenderFns } from "./DashboardSignaturesContainer.vue?vue&type=template&id=a198b3d2&scoped=true"
import script from "./DashboardSignaturesContainer.vue?vue&type=script&lang=js"
export * from "./DashboardSignaturesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a198b3d2",
  null
  
)

export default component.exports